import type { MantineColorsTuple } from '@mantine/core'

export const zincColors: MantineColorsTuple = [
  '#fafafa',
  '#f4f4f5',
  '#e4e4e7',
  '#d4d4d8',
  '#a1a1aa',
  '#52525b',
  '#3f3f46',
  '#27272a',
  '#18181b',
  '#09090b',
  '#71717A',
]
export const slateColors: MantineColorsTuple = [
  '#f8fafc',
  '#f1f5f9',
  '#e2e8f0',
  '#cbd5e1',
  '#94a3b8',
  '#475569',
  '#334155',
  '#1e293b',
  '#0f172a',
  '#020817',
  '#64748B',
]
export const grayColors: MantineColorsTuple = [
  '#f9fafb',
  '#f3f4f6',
  '#e5e7eb',
  '#d1d5db',
  '#9ca3af',
  '#4b5563',
  '#374151',
  '#1f2937',
  '#111827',
  '#030712',
  '#6B7280',
]
export const neutralColors: MantineColorsTuple = [
  '#fafafa',
  '#f5f5f5',
  '#e5e5e5',
  '#d4d4d4',
  '#a3a3a3',
  '#525252',
  '#404040',
  '#262626',
  '#171717',
  '#0a0a0a',
  '#737373',
]
export const stoneColors: MantineColorsTuple = [
  '#fafaf9',
  '#f5f5f4',
  '#e7e5e4',
  '#d6d3d1',
  '#a8a29e',
  '#57534e',
  '#44403c',
  '#292524',
  '#1c1917',
  '#0c0a09',
  '#78716C',
]
export const redColors: MantineColorsTuple = [
  '#FEF2F2',
  '#FEE2E2',
  '#FECACA',
  '#FCA5A5',
  '#F87171',
  '#DC2626',
  '#B91C1C',
  '#991B1B',
  '#7F1D1D',
  '#450A0A',
  '#EF4444',
]
export const roseColors: MantineColorsTuple = [
  '#fff1f2',
  '#ffe4e6',
  '#fecdd3',
  '#fda4af',
  '#fb7185',
  '#e11d48',
  '#be123c',
  '#9f1239',
  '#881337',
  '#4c0519',
  '#F43F5E',
]
export const orangeColors: MantineColorsTuple = [
  '#fff7ed',
  '#ffedd5',
  '#fed7aa',
  '#fdba74',
  '#fb923c',
  '#f97316',
  '#ea580c',
  '#9a3412',
  '#7c2d12',
  '#431407',
  '#F97316',
]
export const amberColors: MantineColorsTuple = [
  '#FFFBEB',
  '#FEF3C7',
  '#FDE68A',
  '#FCD34D',
  '#FBBF24',
  '#f59e0b',
  '#D97706',
  '#92400E',
  '#78350F',
  '#451A03',
  '#F59E0B',
]
export const yellowColors: MantineColorsTuple = [
  '#fefce8',
  '#fef9c3',
  '#fef08a',
  '#fde047',
  '#facc15',
  '#ca8a04',
  '#a16207',
  '#854d0e',
  '#713f12',
  '#3f2c06',
  '#F59E0B',
]
export const limeColors: MantineColorsTuple = [
  '#f7fee7',
  '#ecfccb',
  '#d9f99d',
  '#bef264',
  '#a3e635',
  '#4d7c0f',
  '#3f6212',
  '#365314',
  '#1a2e05',
  '#0f1903',
  '#84CC16',
]
export const greenColors: MantineColorsTuple = [
  '#F0FDF4',
  '#DCFCE7',
  '#BBF7D0',
  '#86EFAC',
  '#4ADE80',
  '#22c55e',
  '#16A34A',
  '#166534',
  '#14532D',
  '#052E16',
  '#10B981',
]
export const emeraldColors: MantineColorsTuple = [
  '#ecfdf5',
  '#d1fae5',
  '#a7f3d0',
  '#6ee7b7',
  '#34d399',
  '#059669',
  '#047857',
  '#065f46',
  '#064e3b',
  '#022c22',
  '#10B981',
]
export const tealColors: MantineColorsTuple = [
  '#f0fdfa',
  '#ccfbf1',
  '#99f6e4',
  '#5eead4',
  '#2dd4bf',
  '#0d9488',
  '#0f766e',
  '#115e59',
  '#134e4a',
  '#042f2e',
  '#14B8A6',
]
export const cyanColors: MantineColorsTuple = [
  '#ecfeff',
  '#cffafe',
  '#a5f3fc',
  '#67e8f9',
  '#22d3ee',
  '#0891b2',
  '#0e7490',
  '#155e75',
  '#164e63',
  '#083344',
  '#06B6D4',
]
export const skyColors: MantineColorsTuple = [
  '#f0f9ff',
  '#e0f2fe',
  '#bae6fd',
  '#7dd3fc',
  '#38bdf8',
  '#0284c7',
  '#0369a1',
  '#075985',
  '#0c4a6e',
  '#082f49',
  '#0EA5E9',
]
export const blueColors: MantineColorsTuple = [
  '#eff6ff',
  '#dbeafe',
  '#bfdbfe',
  '#93c5fd',
  '#60a5fa',
  '#3b82f6',
  '#2563eb',
  '#1e40af',
  '#1e3a8a',
  '#172554',
  '#3B82F6',
]
export const indigoColors: MantineColorsTuple = [
  '#eef2ff',
  '#e0e7ff',
  '#c7d2fe',
  '#a5b4fc',
  '#818cf8',
  '#4f46e5',
  '#4338ca',
  '#3730a3',
  '#312e81',
  '#1e1b4b',
  '#6366F1',
]
export const violetColors: MantineColorsTuple = [
  '#f5f3ff',
  '#ede9fe',
  '#ddd6fe',
  '#c4b5fd',
  '#a78bfa',
  '#7c3aed',
  '#6d28d9',
  '#5b21b6',
  '#4c1d95',
  '#1e1b4b',
  '#8B5CF6',
]
export const purpleColors: MantineColorsTuple = [
  '#faf5ff',
  '#f3e8ff',
  '#e9d5ff',
  '#d8b4fe',
  '#c084fc',
  '#9333ea',
  '#7e22ce',
  '#6b21a8',
  '#581c87',
  '#2e1065',
  '#A855F7',
]
export const fuchsiaColors: MantineColorsTuple = [
  '#fdf4ff',
  '#fae8ff',
  '#f5d0fe',
  '#f0abfc',
  '#e879f9',
  '#c026d3',
  '#a21caf',
  '#86198f',
  '#701a75',
  '#4a044e',
  '#D946EF',
]
export const pinkColors: MantineColorsTuple = [
  '#fdf2f8',
  '#fce7f3',
  '#fbcfe8',
  '#f9a8d4',
  '#f472b6',
  '#db2777',
  '#be185d',
  '#9d174d',
  '#831843',
  '#500724',
  '#EC4899',
]

// Hypersonic brand colors
export const electricCyanColors: MantineColorsTuple = [
  '#ecfeff',
  '#c8fbff',
  '#8ef5ff',
  '#44ecff',
  '#00F2FF',
  '#00CCE0',
  '#00A3B8',
  '#007D90',
  '#005E6E',
  '#003F4D',
  '#00F2FF',
]
export const cyberBlueColors: MantineColorsTuple = [
  '#eef0ff',
  '#dee3ff',
  '#c4caff',
  '#a1abff',
  '#7b87ff',
  '#3D52FF',
  '#3040DB',
  '#2530B0',
  '#1C2488',
  '#141A63',
  '#3D52FF',
]
export const hotMagentaColors: MantineColorsTuple = [
  '#fff0f6',
  '#ffe0ec',
  '#ffc2d9',
  '#ff9cc2',
  '#ff69a8',
  '#FF2E95',
  '#DB1C7C',
  '#B51265',
  '#900D50',
  '#6B083B',
  '#FF2E95',
]
export const grapeColors: MantineColorsTuple = [
  '#F8F0FC',
  '#F3D9FA',
  '#EEBEFA',
  '#E599F7',
  '#DA77F2',
  '#CC5DE8',
  '#BE4BDB',
  '#AE3EC9',
  '#9C36B5',
  '#862E9C',
  '#BE4BDB',
]
export const deepIndigoColors: MantineColorsTuple = [
  '#f3ecff',
  '#e4d6ff',
  '#cfb3ff',
  '#b78cff',
  '#9c5fff',
  '#7C22FF',
  '#6A00FF',
  '#5400D4',
  '#4000A8',
  '#2D0080',
  '#6A00FF',
]
